import * as React from 'react';
import { observer } from 'mobx-react';
import { RightBannerComponent } from 'desktop--design-library';

export interface IRightBannerProps {
    title: string;
    imgSrc: string;
    imgWidth?: number;
    imgHeight?: number;
    asNewWindow?: boolean;
    onClick: () => void;
}

export const RightBannerContainer = observer((props: IRightBannerProps) => {

    return <RightBannerComponent {...props} />
});

